module.exports = __webpack_public_path__ + "images/store_case_study/takagai-pic2_37a3542b583ee9152168cb4f56cc938b.png";